const key = "add-deductions-feature";

const applicable = (resp) => {
	return resp?.config.url.match(/api\/forms\/[0-9]*$/);
};

const deductionsFeature = {
	Id: -1,
	Name: "deductions",
	Type: "Deductions",
	Fields: [
		{
			Order: 0,
			Field: { Id: 956 },
			Properties: { Type: "BUSINESS" }
		},
		{
			Order: 1,
			Field: { Id: 966 },
			Properties: { Type: "CUSTOMER" }
		},
		{
			Order: 2,
			Field: { Id: 978 },
			Properties: { Type: "QUANTITY" }
		},
		{
			Order: 3,
			Field: { Id: 979 },
			Properties: { Type: "PRICE" }
		}
	]
};

const modify = (resp) => {
	if(!resp?.data?.Data)
		return;
	
	resp.data.Data.Features.push(deductionsFeature);
};

export const addDeductionsFeature = [key, applicable, modify];